import React from 'react';
import { getTodaysDate } from '../helpers/date_helpers';

const DateFieldsMovingDate = ({
  movingDateUpdate,
  profileData,
  movingDateError,
  updateProfile,
}) => {
  const handleChange = (event) => {
    const { value, name } = event.target;
    updateProfile(name, value, 'term_preferences');
  };

  const handleBlur = (event) => {
    const { value } = event.target;
    movingDateUpdate(value.trim());
  };

  return (
    <fieldset className="form-group from-group--move-in-date">
      <legend className="form-group__title">
        Preferred move in date{' '}
        <span className="form-group__label-hint">(optional)</span>
      </legend>
      <label className="sr-only" htmlFor="moveInDate">
        Preferred move in date (optional)
      </label>
      <input
        id="moveInDate"
        type="date"
        name="date_available"
        value={profileData?.date_available || ''}
        className="form-group__date-input"
        pattern="\d{4}-\d{2}-\d{2}"
        onBlur={handleBlur}
        onChange={handleChange}
        min={getTodaysDate()}
        placeholder="dd-mm-yyy"
      />
      <p className="form-group__date-error" aria-live="assertive">
        {movingDateError}
      </p>
    </fieldset>
  );
};

export default DateFieldsMovingDate;
